import { render } from "./ReportRemittance.vue?vue&type=template&id=694cb1aa&scoped=true&ts=true"
import script from "./ReportRemittance.vue?vue&type=script&lang=ts"
export * from "./ReportRemittance.vue?vue&type=script&lang=ts"

import "./ReportRemittance.vue?vue&type=style&index=0&id=694cb1aa&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694cb1aa"]])

export default __exports__